import { motion } from 'framer-motion';
import { GachiClicker } from '@/components/GachiClicker';
import { SnowGenerator } from '@/components/SnowGenerator';
import { playClickSound } from '@/utils/sounds';
import { triggerButtonHaptic } from '@/utils/haptics';
import spaBg from '@/assets/spa-bg.jpg';

interface SPABlockProps {
  snowActive: boolean;
  onToggleSnow: () => void;
}

export function SPABlock({ snowActive, onToggleSnow }: SPABlockProps) {
  const handleToggleSnow = () => {
    playClickSound();
    triggerButtonHaptic();
    onToggleSnow();
  };

  return (
    <motion.section
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className="min-h-screen relative overflow-hidden"
      aria-label="Тепловая Нормализация - SPA Zone"
    >
      {/* Warm SPA background image */}
      <div 
        className="absolute inset-0 z-0"
        style={{
          backgroundImage: `url(${spaBg})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
        }}
      />
      {/* Warm overlay gradient */}
      <div className="absolute inset-0 z-0 bg-gradient-to-b from-amber-900/70 via-orange-900/60 to-red-900/70" />
      
      <SnowGenerator active={snowActive} />

      <div className="relative z-10 max-w-4xl mx-auto px-4 sm:px-8 py-8 sm:py-16">
        <motion.h2 
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          className="text-3xl sm:text-4xl font-bold text-white/90 mb-2 sm:mb-4 text-center"
        >
          Тепловая Нормализация
        </motion.h2>
        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.2 }}
          className="text-white/60 text-center mb-8 sm:mb-12 text-sm font-mono"
        >
          BatchNorm для тела и души 🧖‍♂️
        </motion.p>

        <div className="space-y-12">
          {/* Gachi Clicker */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.2 }}
            className="p-6 sm:p-8 bg-black/30 backdrop-blur-md border border-white/10 rounded-lg"
          >
            <GachiClicker />
          </motion.div>

          {/* Snow Generator Button */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.4 }}
            className="flex justify-center"
          >
            <motion.button
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              onClick={handleToggleSnow}
              className="px-6 sm:px-8 py-3 sm:py-4 bg-white/10 hover:bg-white/20 backdrop-blur-md border border-white/20 rounded-sm text-white/90 font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-white/30 min-h-[44px] text-sm sm:text-base"
              aria-label={snowActive ? 'Остановить снег' : 'Включить снег'}
            >
              {snowActive ? '❄️ Остановить снег' : '❄️ Включить снег'}
            </motion.button>
          </motion.div>
        </div>
      </div>
    </motion.section>
  );
}
